import type { FC } from "react";
import { LogComponent, MethodForm, WorkspaceForm } from "./components";
import { FormContainer } from "./form-components.styles";
import type { FormComponentProps } from "./form-component.types";
import { getKeyWordsForm } from "@src/core/utils";

export const FormComponent: FC<FormComponentProps> = ({ pathname }) => {
  const { formType, formMethod } = getKeyWordsForm(pathname);

  const getTitle = () => {
    if (formType === 'workspace') {
      return formMethod === 'update'
        ? 'Редактирование пространства'
        : 'Создание пространства';
    }
    if (formType === "routes") {
      return formMethod === "create"
        ? "Создание метода"
        : "Редактирование метода";
    }
  };

  const titleForm = getTitle();

  return (
    <FormContainer formType={formType} formMethod={formMethod}>
      {formType === 'workspace' && titleForm && (
        <WorkspaceForm titlePage={titleForm} />
      )}
      {formType === "routes" && titleForm && (
        <MethodForm titlePage={titleForm} />
      )}
      {formMethod && formType === "routes" && (
        <LogComponent formType={formType} formMethod={formMethod} />
      )}
    </FormContainer>
  );
};
